module.exports = __webpack_public_path__ + "static/media/gamepad.41fc5eda.svg";